export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Currency"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Create report"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Currency result"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Download"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sheet"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Allowed file format - xlsx"])}
}